import React, {Component} from 'react'
import {Player, ControlBar, PosterImage} from 'video-react'
import {
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  Col
} from 'reactstrap'

import '../../node_modules/video-react/dist/video-react.css'
import './custom.css'

const sources = {
  sintel: 'https://media.w3.org/2010/05/sintel/trailer_hd.mp4',
  bunnyMovie: 'https://media.w3.org/2010/05/bunny/movie.mp4',
  elephants: '//d2zihajmogu5jn.cloudfront.net/elephantsdream/ed_hd.mp4'
}

const posters = {
  sintel: 'https://video-react.js.org/assets/poster.png',
  bunnyMovie: '//d2zihajmogu5jn.cloudfront.net/big-buck-bunny/bbb.png',
  elephants: '//d2zihajmogu5jn.cloudfront.net/elephantsdream/poster.png'
}

class PlayerControl extends Component {
  constructor(props, context) {
    super(props, context)

    this.state = {
      source: sources['bunnyMovie'],
      poster: posters['bunnyMovie']
    }

    this.play = this.play.bind(this)
    this.pause = this.pause.bind(this)
    this.load = this.load.bind(this)
    this.changeCurrentTime = this.changeCurrentTime.bind(this)
    this.seek = this.seek.bind(this)
    this.changePlaybackRateRate = this.changePlaybackRateRate.bind(this)
    this.changeVolume = this.changeVolume.bind(this)
    this.setMuted = this.setMuted.bind(this)
    }

  componentDidMount() {
    // subscribe state change
    this.refs.player.subscribeToStateChange(this.handleStateChange.bind(this))
  }

  handleStateChange(state, prevState) {
    // copy player state to this component's state
    this.setState({player: state})
  }

  play() {
    this.refs.player.play()
  }

  pause() {
    this.refs.player.pause()
  }

  load() {
    this.refs.player.load()
  }

  changeCurrentTime(seconds) {
    return() => {
      const {player} = this.refs.player.getState()
      const currentTime = player.currentTime
      this.refs.player.seek(currentTime + seconds)
    }
  }

  seek(seconds) {
    return() => {
      this.refs.player.seek(seconds)
    }
  }

  changePlaybackRateRate(steps) {
    return() => {
      const {player} = this.refs.player.getState()
      const playbackRate = player.playbackRate
      this.refs.player.playbackRate = playbackRate + steps
    }
  }

  changeVolume(steps) {
    return() => {
      const {player} = this.refs.player.getState()
      const volume = player.volume
      this.refs.player.volume = volume + steps
    }
  }

  setMuted(muted) {
    return() => {
      this.refs.player.muted = muted
    }
  }

  changeSource(name) {
    return() => {
      this.setState({source: sources[name]})
      this.setState({poster: posters[name]})
      this.refs.player.load()
    }
  }

  render() {
    return (<div>
      <Player ref="player" poster={this.state.poster} src={this.state.source}>
        <ControlBar autoHide={true}/>
      </Player>
      <div className="py-3">
        <Button onClick={this.play} className="mr-3">
          play
        </Button>
        <Button onClick={this.pause} className="mr-3">
          pause
        </Button>
        <Button onClick={this.load} className="mr-3">
          load
        </Button>
      </div>

      <div className="pb-3">
        <Button onClick={this.changeSource('bunnyMovie')} className="mr-3">
          Bunny Movie
        </Button>
        <Button onClick={this.changeSource('elephants')} className="mr-3">
          Elephants Dream
        </Button>
        <Button onClick={this.changeSource('sintel')} className="mr-3">
          Sintel
        </Button>
      </div>
    </div>)
  }
}

export default PlayerControl;



// WEBPACK FOOTER //
// ./src/components/PlayerControl.js